<form
    class="flex flex-col items-center p-10"
    [formGroup]="form">
    <h1 class="mb-5 text-2xl font-medium">Add new goal</h1>
    <mat-form-field>
        <mat-label>Goal type</mat-label>
        <mat-select formControlName="goalType">
            @for (keyValue of CampaignOfferGoalType | appEnumKeyValue; track $index) {
                <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <button
        class="self-stretch"
        mat-flat-button
        color="primary"
        (click)="addGoal()">
        Add
    </button>
</form>
